import axios from 'axios';
import { OpenAPI } from './generated/core/OpenAPI';
import { refreshAccessToken } from './auth';

// Configure the OpenAPI client to use the same settings as our custom axios instance
// Note: The generated endpoints already include /api prefix, so BASE URL should be just the host
const backendUrl = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:5000';
// Remove /api suffix if present since generated endpoints already have it
OpenAPI.BASE = backendUrl.replace(/\/api\/?$/, '');
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.CREDENTIALS = 'include';

// The generated client sends every request through the *global* axios instance
// (generated/core/request.ts defaults `axiosClient` to `axios`), so it never sees
// the refresh-token interceptor registered on the `api` instance in axiosConfig.ts.
// Without this, any generated-client call fails outright once the access token
// expires, while hand-written calls transparently recover. `refreshAccessToken`
// itself goes through `api`, so it cannot re-enter this interceptor.
const isPublicPath = (path: string): boolean =>
    ['/login', '/register', '/reset-password', '/request-password-reset', '/accept-invitation', '/'].includes(path);

let isRefreshing = false;
let refreshSubscribers: Array<() => void> = [];

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status !== 401 || !originalRequest || originalRequest._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        if (isRefreshing) {
            return new Promise(resolve => {
                refreshSubscribers.push(() => resolve(axios(originalRequest)));
            });
        }

        isRefreshing = true;

        try {
            await refreshAccessToken();
            refreshSubscribers.forEach(callback => callback());
            refreshSubscribers = [];
            return axios(originalRequest);
        } catch (refreshError) {
            refreshSubscribers = [];
            if (!isPublicPath(window.location.pathname)) {
                window.location.href = '/login';
            }
            return Promise.reject(refreshError);
        } finally {
            isRefreshing = false;
        }
    }
);

export { OpenAPI };
